"use strict";

import {Renderer} from './renderer.js';
import {Listener} from './listener.js';
import {DnD} from './dnd.js';
import {jQ} from './jq.js'; // modul zpětné kompatibility s jQuery //



export class ComboBox {
    
    static init(element, a,b,c) {
        
        if (!ComboBox.inited) {

            ComboBox.jstr=(typeof window.jstr=='function')&&(window.jstr('test','test')==='test')?window.jstr:(v)=>v;

            ComboBox.inherit=[
            
                {
                    rule:'.bs_popover', // co musí input.matches(), aby se dědily vlastnosti? string
                    classList:'bs_popover', // jakou třídu přidat comboboxu? string nebo array!!
                    attributes:['data-content', 'data-trigger', 'data-original-title'], // jaké atributy zdědit? string nebo array!!
                    call:'initPopover',
                }, 
                
            ]

            ComboBox.Renderer=Renderer;
            ComboBox.Listener=Listener;
            ComboBox.DnD=Listener;
            ComboBox.jQ=jQ;
            
            Renderer.init(ComboBox);
            Listener.init(ComboBox);
            DnD.init(ComboBox);
            jQ.init(ComboBox);

            ComboBox.inited=true;
            ComboBox.request=0;
                        
        }

        if ((element instanceof HTMLElement)&&(element.matches('input[data-source], select'))) {

            Renderer.make(element, a);
            jQ.jQuery(element, a,b,c);
            
            
        }
        
    }

    static getOptionAlreadyChecked(option) {
        
        if (ComboBox.input&&ComboBox.input.matches('select')&&ComboBox.input.multiple) {
            let options=ComboBox.input.querySelectorAll('option');
            for (let i=0, l=options.length; i<l; i++) {
                if ((options[i].value==option.value)&&options[i].selected) return true;
            }
        }
        
        return false;
        
    }

    static parseAjaxOptions(options) {
        let search;
        if (ComboBox.target&&ComboBox.target.value) {
            search=ComboBox.target.value;
            if (typeof search.normalize === 'function') {
                search=search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            }
        };
        let indexedOptions=options.map((o)=>{
            return {
                display:o.value||o.id, 
                value:o.id, 
                short:o.short||"",//||o.value||o.id,
                disabled:o.disabled,
            }
        }).map((o)=>{
            let index=0;
            if (search) {
                let value=o.display||o.value;
                if (typeof value.normalize === 'function') {
                    value=value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                }
                index=value.indexOf(search);
            }
            return {option:o, index:index}
        });

        return [
            ...indexedOptions.filter((io)=>!io.index),
            ...indexedOptions.filter((io)=>io.index)
        ].map((o)=>o.option);

    }

    static response(action) {
        ComboBox.ajaxMessage = action.message || null;
        ComboBox.ajaxResponse = action.options;
    }

    static ajaxThen(request, data) {
        if (request!=ComboBox.request) return; // zahození staré response; ajax to dělá sám, ale zde je tím ošetřeno přepnutí na jinek kombáč během requestu...
        if (!Array.isArray(ComboBox.ajaxResponse ??= data.data.options)) throw 'neobdržena data pro combobox.';
        ComboBox.ajaxMessage ??= data.data.message ?? null;
        ComboBox.options=ComboBox.parseAjaxOptions(ComboBox.ajaxResponse);
    };
    
    static ajaxCatch(request, data) {
        if (request!=ComboBox.request) return; // zahození staré response; ajax to dělá sám, ale zde je tím ošetřeno přepnutí na jinek kombáč během requestu...
        console.error('Combobox: ', data);
        ComboBox.ajax_err=true;
    };

    static ajaxFinally(request) {
        if (request!=ComboBox.request) return; // zahození staré response; ajax to dělá sám, ale zde je tím ošetřeno přepnutí na jinek kombáč během requestu...
        delete ComboBox.ajaxResponse;
        if (ComboBox.combo) {ComboBox.combo.classList.remove('loading');}
        ComboBox.ajax_pending=false;
        ComboBox.Renderer.show();
    }

    static ajax() { 
        if (ComboBox.Ajax&&ComboBox.target&&ComboBox.ajax_url) {
            ComboBox.ajaxMessage=null;
            if (ComboBox.target.value.length<(ComboBox.minLength||0)) {ComboBox.options=[];}
            ComboBox.ajax_err=false;
            clearTimeout(ComboBox.timeout);

            if ((ComboBox.lastSearch!==null)&&(ComboBox.target.value.length>=(ComboBox.minLength||0))) {

                ComboBox.combo.classList.add('loading');
                if (ComboBox.container&&ComboBox.options.length) {ComboBox.container.style.opacity='.3';}
                let value=ComboBox.target.value;
                ComboBox.ajax_pending=true;

                ComboBox.timeout=setTimeout(()=>{

                    if (!ComboBox.ajax_url) {ComboBox.ajax_pending=false; return; }
                    
                    if (!ComboBox.input) {ComboBox.ajax_pending=false; return; }

                    ComboBox.request++;

                    let ajax = new window.VutRequiredLib.Ajax(ComboBox.ajax_url, 'GET');
                    ajax.addData(ComboBox.ajax_param||'term', value);

                    if (ComboBox.query) {
                        let q = ComboBox.query.replace(/^\?/, '').split('&');
                        q.forEach((q)=>{
                            let split = q.split ('=');
                            ajax.addData(split.shift(), split.join('='));
                        })
                    }

                    ComboBox.Ajax.doAjax(ajax)
                        .then(ComboBox.ajaxThen.bind(null, ComboBox.request))
                        .catch(ComboBox.ajaxCatch.bind(null, ComboBox.request))
                        .finally(ComboBox.ajaxFinally.bind(null, ComboBox.request))

                    
                }, 250);

            } else {
                ComboBox.combo.classList.remove('loading');                
            }
        
        }

    }
    
    
    
    static install(q, a,b,c) {

        if (q instanceof HTMLElement) {
            
            ComboBox.init(q, a,b,c);

        } else {
            
            try {

                let all=document.querySelectorAll(q);
                Array.from(all).forEach((e)=>ComboBox.init(e, a,b,c));

            } catch(e) {console.error(e);}
            
        }
        
        Renderer.resize();

    }
    
    
    
    
    
    
    
    
}
